import React from 'react';

import { useMutation } from '@tanstack/react-query';

import useContactForm from '../../../../../../../forms/admin/contact';

import FormContainer from '../../../../../FormContainer';
import { useUiContext } from '../../../../../../../context/UiContext';
import ContactService from '../../../../../../../services/ContactService';

export default function ContactForm({
  title,
  groupSizeOffset,
  contact,
  servicerId,
  type,
  refetch,
}) {
  const { showToast } = useUiContext();

  const { mutate: createContact } = useMutation({
    mutationFn: (formValues) =>
      ContactService.createContact({ formValues, servicerId, type }),
    onSuccess: () => {
      showToast({ type: 'success', text: 'Contact created' });
      refetch();
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const { mutate: updateContact } = useMutation({
    mutationFn: (formValues) =>
      ContactService.updateContact({ formValues, contactId: contact.id, type }),
    onSuccess: () => {
      showToast({ type: 'success', text: 'Contact updated' });
      refetch();
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const contactForm = useContactForm(
    contact ? updateContact : createContact,
    contact,
    title
  );

  return (
    <div className="relative p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <FormContainer form={contactForm} groupSizeOffset={groupSizeOffset} />
    </div>
  );
}
